import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function ModalConfirmacionFacturacion({ show, onConfirm, onCancel }) {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmación de Facturación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3">¿Desea realizar la factura en este momento?</p>
                <ul className="text-muted small">
                    <li><strong>SÍ:</strong> La factura se generará inmediatamente y podrá enviarla a la DIAN.</li>
                    <li><strong>NO:</strong> Se generará una factura en borrador para ser procesada próximamente por el personal de facturación.</li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => onConfirm(false)}>
                    NO - Crear Borrador
                </Button>
                <Button variant="primary" onClick={() => onConfirm(true)}>
                    SÍ - Facturar Ahora
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalConfirmacionFacturacion;
